import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { msalInstance } from './app/app.msal';

msalInstance.initialize().then(() => {
  bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
  }).catch(err => console.error('MSAL initialization failed',err));
